import { useFlippers } from "../useFlippers";

const useIsFs2JanRelease = () => {
  const [isMegamenuEnabled] = useFlippers("cura_megamenu_2023q4_fs_web_release");

  return isMegamenuEnabled;
};

export { useIsFs2JanRelease };
